import { Controller } from "@hotwired/stimulus"
import { dedupeByEmail, contactRow, emptyMessage } from "../lib/contact_list"

// Powers the contact-group modal: checking a category auto-checks its
// individual members, and a live "Sending to" preview always reflects
// exactly who is currently selected.
export default class extends Controller {
  static targets = ["entryCheckbox", "leadCheckbox", "entryCategoryCheckbox", "leadCategoryCheckbox", "preview", "count", "entrySearch", "leadSearch"]
  static values = { categoryEntryMap: Object, leadCategoryMap: Object }

  connect() {
    this.entryCategoryCheckboxTargets.filter((checkbox) => checkbox.checked)
      .forEach((checkbox) => this.applyCategory(this.categoryEntryMapValue[checkbox.value], true, this.entryCheckboxTargets))
    this.leadCategoryCheckboxTargets.filter((checkbox) => checkbox.checked)
      .forEach((checkbox) => this.applyCategory(this.leadCategoryMapValue[checkbox.value], true, this.leadCheckboxTargets))
    this.refreshPreview()
  }

  applyCategory(ids, checked, checkboxes) {
    const set = (ids || []).map(String)
    checkboxes.forEach((checkbox) => {
      if (set.includes(checkbox.value)) checkbox.checked = checked
    })
  }

  toggleEntryCategory(event) {
    this.applyCategory(this.categoryEntryMapValue[event.target.value], event.target.checked, this.entryCheckboxTargets)
    this.refreshPreview()
  }

  toggleLeadCategory(event) {
    this.applyCategory(this.leadCategoryMapValue[event.target.value], event.target.checked, this.leadCheckboxTargets)
    this.refreshPreview()
  }

  filterEntries(event) {
    this.filterList(this.entryCheckboxTargets, event.target.value)
  }

  filterLeads(event) {
    this.filterList(this.leadCheckboxTargets, event.target.value)
  }

  filterList(checkboxes, query) {
    const q = query.toLowerCase()
    checkboxes.forEach((checkbox) => {
      const label = checkbox.closest("label")
      label.classList.toggle("hidden", !label.textContent.toLowerCase().includes(q))
    })
  }

  refreshPreview() {
    const contacts = [...this.entryCheckboxTargets, ...this.leadCheckboxTargets]
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => ({ name: checkbox.dataset.name, email: checkbox.dataset.email }))

    const unique = dedupeByEmail(contacts)

    this.countTarget.textContent = unique.length

    if (unique.length === 0) {
      this.previewTarget.replaceChildren(emptyMessage("No recipients selected yet"))
      return
    }

    this.previewTarget.replaceChildren(...unique.map(contactRow))
  }
}
